import React, { useState } from 'react';
import Layout from '../../layout/Layout';
import LoginSelector from './LoginSelector/LoginSelector';
import LoginForm from './LoginForm';
import { Snackbar } from '@bcmi-labs/react-components';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const loginCoppa = urlParams.get('loginCoppa');
  const redirectUri = urlParams.get('redirect_uri');
  const [selectedView, setSelectedView] = useState(loginCoppa);
  const [showChildAttemptSnackbar, setShowChildAttemptSnackbar] = useState(false);

  const { t } = useTranslation('login');

  if (selectedView === 'login-selector') {
    return (
      <Layout onBack={redirectUri ? () => (window.location.href = redirectUri) : null} isChild={false}>
        <LoginSelector onViewSelection={(value) => setSelectedView(value)} />
      </Layout>
    );
  } else {
    return (
      <Layout
        onBack={
          loginCoppa
            ? () => setSelectedView('login-selector')
            : redirectUri
            ? () => (window.location.href = redirectUri)
            : null
        }
        isChild={selectedView === 'kid-login'}
      >
        <LoginForm
          isFromCoppa={!!loginCoppa}
          isChild={selectedView === 'kid-login'}
          onViewSelection={(value) => setSelectedView(value)}
          showChildAttempt={(value) => setShowChildAttemptSnackbar(value)}
        />
        <Snackbar
          message={t('login:childLoginAttempt')}
          isOpen={showChildAttemptSnackbar}
          onClose={() => setShowChildAttemptSnackbar(false)}
          turnOffAutoHide
          closeable
        ></Snackbar>
      </Layout>
    );
  }
};

export default Login;
